<script>
	import Login from '../../../components/Login.svelte';
</script>

<Login task={'whoopLogin'} />
